import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — força scroll ao topo a cada mudança de rota.
 *
 * Por que existir:
 *   React Router preserva a posição do scroll entre navegações por padrão.
 *   Para uma SPA com layouts de listagem extensos, isso confunde o usuário
 *   ("cliquei em algo e a página apareceu no meio").
 *
 * Estratégia:
 *   - Reage a `pathname` e `search` (não a `hash`, para deixar âncoras tipo
 *     "#section" navegáveis normalmente).
 *   - Usa `instant` (sem animação) — animação suave atrapalha quando o
 *     destino é uma página totalmente diferente.
 *   - Respeita também o caso em que o usuário usa botão "voltar" do
 *     navegador: o `useEffect` dispara mesmo nesse cenário.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // não interfere quando há âncora explícita
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      // Safari < 14 não conhece `behavior: 'instant'`
      window.scrollTo(0, 0);
    }
  }, [pathname, search, hash]);

  return null;
}
